var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 20.3V9.49226C20 9.16189 19.8368 8.85284 19.564 8.6665L12.564 3.88525C12.2239 3.65293 11.7761 3.65293 11.436 3.88525L4.43598 8.6665C4.16317 8.85283 4 9.16189 4 9.49226V20.3C4 20.4105 4.08954 20.5 4.2 20.5H9.4C9.51046 20.5 9.6 20.4105 9.6 20.3V16.1676C9.6 15.8914 9.82386 15.6676 10.1 15.6676H13.9C14.1761 15.6676 14.4 15.8914 14.4 16.1676V20.3C14.4 20.4105 14.4895 20.5 14.6 20.5H19.8C19.9105 20.5 20 20.4105 20 20.3Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.46c0fe130c07544dad9a6e77b577c274.svg";
export { ForwardRef as ReactComponent };